/**
 * Generic "zoom in" modal — used to display an enlarged StrikeZone or
 * MiniHitDiamond when the user clicks its inline thumbnail inside the
 * InningDetailModal. Stacks above the inning modal via the modalStack
 * gate.
 */
import Modal from './Modal';
import styles from './ZoomModal.module.css';

interface ZoomModalProps {
  open: boolean;
  onClose: () => void;
  ariaLabel: string;
  children: React.ReactNode;
}

export default function ZoomModal({
  open,
  onClose,
  ariaLabel,
  children,
}: ZoomModalProps): JSX.Element | null {
  return (
    <Modal open={open} onClose={onClose} ariaLabel={ariaLabel} size="md" testid="zoom-modal">
      <div className={styles.body}>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close zoom"
          data-testid="zoom-modal-close"
          className={styles.close}
        >
          ×
        </button>
        <div className={styles.content}>{children}</div>
      </div>
    </Modal>
  );
}
